import { render, staticRenderFns } from "./filter_tabs.vue?vue&type=template&id=1ba377e6&"
import script from "./filter_tabs.vue?vue&type=script&lang=js&"
export * from "./filter_tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports